import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Chip, TextField } from '@mui/material';
import { AlumnoType, PayloadAlumnoType } from '../../types/types';
import { useState } from 'react';


interface AlumnosParaAgregarAlGrupoPrps {
  open: boolean;
  onCancell: () => void;
  agregar: { alumnos?: AlumnoType[], grupo: string } | null;
  setMutableAlumno: React.Dispatch<React.SetStateAction<PayloadAlumnoType | undefined>>
}

export default function AlumnosParaAgregarAlGrupo(props: AlumnosParaAgregarAlGrupoPrps) {
  const { open, onCancell, setMutableAlumno, agregar } = props;
  const [filtro, setFiltro] = useState('');

  if (!agregar) return null;
  const { grupo, alumnos } = agregar;
  const filtrado = alumnos?.filter((a) => a.apellido?.toUpperCase().includes(filtro?.toUpperCase())
  || a.name?.toUpperCase().includes(filtro?.toUpperCase()));


  if (!grupo) return null;

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth='md'
        PaperProps={{
          sx: {
            minHeight: '70vh',
            maxHeight: '70vh',
          },
        }}
      >
        <DialogTitle>Alumnos sin grupo asignado</DialogTitle>
        <DialogContent>
          <Box style={{ marginTop: 24 }}>
            <TextField
              margin="dense"
              id="buscar"
              label="Buscar"
              type="text"
              fullWidth
              variant="standard"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFiltro(event.target.value);
              }}
              value={filtro}
            />
            {filtrado?.filter((a:AlumnoType) => !a.grupo).map((a) => (
              <Chip
                key={a._id}
                label={`${a.name} ${a.apellido}`}
                onClick={() => {
                  setMutableAlumno({ ...a, grupo });
                  a.grupo = grupo;
                }}
                size="small"
                style={{ margin: 4 }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancell}>Salir</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
